import {Pipe, PipeTransform} from "@angular/core";
import {Patient} from "../patient/models/patient";
import {PatientId} from "../patient/models/patient.id";
import {PatientUtilsService} from "../../patient.utils/services/patient.utils.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {PatientIdIssuerService} from "../../patient.utils/services/patient.id.issuer.service";

@Pipe({name: 'cpPatientId', pure: true})
export class PatientIdPipe implements PipeTransform {

	constructor(private patientUtilsService: PatientUtilsService,
				private patientIdIssuerService: PatientIdIssuerService) {
	}

	transform(value: Patient|PatientId|PatientId[], displayIssuer: boolean, displayDefaultIssuer: boolean = false): Observable<string> {
		// this is funny - we do a lot of work here just because we're not sure if the patient-id we received is the primary
		// we may be able to find it out more easily
		return this.patientIdIssuerService.getPrimaryIdIssuerKeyObservable(value).pipe(map(key => {
			return this.patientUtilsService.getPrimaryId(value, displayIssuer, displayDefaultIssuer, this.patientUtilsService.implementMask(key));
		}));
	}
}
